import { Box } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import * as FilestackUrls from "@outschool/filestack-urls";
import { enrolledPath } from "@outschool/routes";
import { plural } from "@outschool/text";
import * as Time from "@outschool/time";
import { dayjs } from "@outschool/time";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import * as Activity from "../../../shared/Activity";
import * as Enrollment from "../../../shared/Enrollment";
import { useTimeZone } from "../../providers/TimeZoneProvider";
import { MeetingListing } from "../CalendarTypes";
import Link from "../Link";

type ScheduleMeetingListing = {
  meetingListing: MeetingListing;
};

export default function ScheduleMeetingListing({
  meetingListing: { meeting, section, activity, enrollments }
}: ScheduleMeetingListing) {
  const { timeZone: userTimeZone } = useTimeZone();
  const isMobile = useIsMobile();
  const startTime = meeting?.start_time || section.start_time;
  const endTime = meeting?.end_time || section.end_time;
  const startDayjs = dayjs.tz(startTime, userTimeZone);
  const endDayjs = dayjs.tz(endTime, userTimeZone);
  const isFlexScheduleOrClub =
    Activity.isFlexSchedule(activity) || activity.isClub;
  const opacity = endDayjs.unix() * 1000 > Date.now() ? 1.0 : 0.4;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        justifyContent: "space-between"
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          justifyContent: "flex-start"
        }}
      >
        {!isMobile && (
          <Box
            sx={{
              marginRight: "1em",
              textAlign: "center"
            }}
          >
            <Box
              sx={{
                border: "2px solid #e5e5e5 !important"
              }}
            >
              <Box
                sx={{
                  fontSize: "0.8em",
                  fontWeight: "bold",
                  backgroundColor: "#e5e5e5",
                  color: "#FFF",
                  borderColor: "#FFF",
                  paddingX: "0.75em !important"
                }}
              >
                {startDayjs.format("MMM").toUpperCase()}
              </Box>
              <Box
                sx={{
                  color: "#808080"
                }}
              >
                {startDayjs.format("D")}
                {isFlexScheduleOrClub && `-${endDayjs.format("D")}`}
              </Box>
            </Box>
          </Box>
        )}
        <div style={{ opacity }}>
          {isMobile && (
            <div>
              <Box
                sx={{
                  fontWeight: 500
                }}
              >
                {isFlexScheduleOrClub
                  ? Time.briefDurationStringWithoutTimes(
                      startTime,
                      endTime,
                      userTimeZone
                    )
                  : `${startDayjs.format("dddd")} ${startDayjs.format(
                      "MMMM Do"
                    )}`}
              </Box>
              <div>
                {isFlexScheduleOrClub
                  ? "Flexible schedule"
                  : Time.startEndTime(startTime, endTime, userTimeZone)}
              </div>
            </div>
          )}
          {!isMobile && (
            <>
              {isFlexScheduleOrClub ? (
                "Flexible schedule"
              ) : (
                <div>
                  {startDayjs.format("dddd")},{" "}
                  {Time.startEndTime(startTime, endTime, userTimeZone)}
                </div>
              )}
            </>
          )}
          <div>
            {enrollments && (
              <React.Fragment>
                <span data-private>
                  {Enrollment.studentNamesString(enrollments)}
                </span>
                {plural(" has ", enrollments.length, " have ")}
              </React.Fragment>
            )}
            <Link to={enrolledPath(section.uid)}>{activity.title}</Link>
          </div>
        </div>
      </Box>
      {!isMobile && (
        <ActivityThumbnail
          photo={activity.details.photo}
          title={activity.title}
        />
      )}
    </Box>
  );
}

export function ScheduleClubListing({ event }: $TSFixMe) {
  const { section } = event;
  const { activity } = section;
  const isMobile = useIsMobile();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          justifyContent: "space-between"
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "stretch",
            justifyContent: "flex-start"
          }}
        >
          <div>
            <div>
              {section.validEnrollmentCount && (
                <React.Fragment>
                  <span data-private>{section.validEnrollmentCount}</span>
                  {plural(" active learner", section.validEnrollmentCount)}
                </React.Fragment>
              )}
            </div>
            <Link to={enrolledPath(section.uid)}>{activity.title}</Link>
          </div>
        </Box>
        {!isMobile && (
          <ActivityThumbnail
            photo={activity.details.photo}
            title={activity.title}
          />
        )}
      </Box>
      <hr
        style={{
          marginTop: "1em",
          marginBottom: "1em"
        }}
      ></hr>
    </>
  );
}

function ActivityThumbnail({
  photo,
  title
}: {
  photo: string | null;
  title: string;
}) {
  return (
    <img
      style={{ width: 95, height: 50, marginLeft: "1em" }}
      src={FilestackUrls.imageUrl(photo, {
        w: 190,
        h: 100
      })}
      alt={title}
    />
  );
}
